/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.redeemAmazonCatalogueItem.internal

import features.redeemAmazonCatalogueItem.models.RedeemAmazonItemRequest
import features.redeemAmazonCatalogueItem.models.RedeemResponseModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class RedeemAmazonCatalogueItemsServiceImpl : RedeemAmazonCatalogueItemsService {

    private val redeemAmazonCatalogueItemsRequest = RedeemAmazonCatalogueItemsRequest()

    override suspend fun redeemAmazonCatalogueItem(
        overrideHeaders : Map<String, String>?,
        redeemAmazonItemRequest: RedeemAmazonItemRequest    ): Result<RedeemResponseModel> {
        return redeemAmazonCatalogueItemsRequest.redeemAmazonCatalogueItem(
            overrideHeaders = overrideHeaders,
            redeemAmazonItemRequest = redeemAmazonItemRequest        ).toModel()
    }
}
